import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M22.776 4.503a1 1 0 0 1 1.34-.07l.076.069 3.3 3.3.069.075c.32.392.297.972-.069 1.339l-2.066 2.069 1.537 1.537.064.078a.5.5 0 0 1-.064.63l-.707.706-.078.065a.501.501 0 0 1-.551 0l-.078-.065-1.536-1.536-13.04 13.063c-.133.132-.3.226-.484.268l-4.288.988-.134.023a1.002 1.002 0 0 1-1.087-1.088l.022-.134.99-4.289a.979.979 0 0 1 .175-.377l.09-.104L19.3 7.986l-1.53-1.528-.065-.078a.5.5 0 0 1 .065-.63l.707-.706a.5.5 0 0 1 .628-.065l.079.065L20.71 6.57l2.066-2.067ZM14.124 16h3.769l4.706-4.714L20.713 9.4 14.124 16Z" stroke="none"></path>';
export var ColorPickerSVG = function ColorPickerSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ColorPickerSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ColorPickerSVG);